export abstract class CustomError extends Error {
	public needLog: boolean = true;
	public abstract getExtras(): Record<string, any>;
}
